export default {
  sync: (patterns) => [].concat(patterns),
}
